import React, {useEffect, useState} from 'react';
import {ShiftCard} from "../../components";
import {SortByItem, SortByLists} from "../../core-ui/sort-list/sort-list";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {fetchData} from "../../helpers/general-function";
import {Modal} from 'react-responsive-modal';
import {ShiftModalContainer, ZoneOptions} from "./requests.styles";
import Sheet from 'react-modal-sheet';
import MobileSort from "../../components/mobile-sort/mobile-sort";
import {CustomSheet, MobileSortItem} from "../../components/mobile-sort-item/mobile-sort-item.styles";

const SHIFT_ORDERS = [
    {name: 'جدید ترین', order: 'latest'},
    {name: 'نزدیک ‌ترین زمان شیفت', order: 'closest_shift'},
    {name: 'بیشترین حق الزحمه', order: 'most_earning'},
    {name: 'کمترین حق الزحمه', order: 'least_earning'},
    {name: 'بیشترین مدت شیفت', order: 'most_duration'},
    {name: 'کمترین مدت شیفت', order: 'least_duration'},
];

const ZONE_DATA = {
    provinceId: 'not-selected',
    cityId: 'not-selected',
}

const Requests = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [shifts, setShifts] = useState([]);
    const [activeOrder, setActiveOrder] = useState('latest');
    const [shiftsModal, setShiftsModal] = useState([]);
    const [mobileSortModal, setMobileSortModal] = useState(false);
    const [cities, setCities] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [zoneData, setZoneData] = useState(ZONE_DATA);

    const order = searchParams.get('order');
    const city_id = searchParams.get('city_id');
    const province_id = searchParams.get('province_id');

    //Just one time
    useEffect(() => {
        (async () => {

            const provincesData = await fetchData('assets/provinces', 'get', {});

            if (provincesData) {
                setProvinces(provincesData.provinces);

                if (province_id && city_id) {
                    const cityData = await fetchData(`assets/provinces/${province_id}/cities`, 'get', {});

                    if (cityData) {
                        setCities(cityData.cities);
                        setZoneData({cityId: city_id, provinceId: province_id});
                    }
                }
            }
        })();
    }, []);

    //Reloading when sort is changed
    useEffect(() => {
        (async () => {
            console.log('fdv')

            if (!order) {
                navigate('/requests?order=latest');
                return false;
            }

            let dataParams = {order, limit: '16'};

            if (city_id) {
                dataParams = {...dataParams, province_id, city_id};
            }

            const data = await fetchData('shifts', 'get', dataParams, true);

            if (data) {
                setShifts(data.shifts);
                setActiveOrder(order);
                if (mobileSortModal) {
                    setMobileSortModal(false)
                }
            }

        })()

    }, [order]);

    const shiftsModalHandler = (shift) => {

        const finalShiftModal = shift.shift_times.map((item) => ({
            id: shift.id,
            shift_times: [{from: item.from, to: item.to}],
            shift_start: item.from,
            pharmacy: shift.pharmacy,
            is_instant: shift.is_instant,
            total_earnings: item.earning,
            total_duration: '3',
        }))
        setShiftsModal(finalShiftModal);
    }

    const zoneChangeHandler = async ({target: {name, value}}) => {
        if (name === 'cityId') {
            const data = await fetchData('shifts', 'get', {
                order: activeOrder,
                limit: '16',
                province_id: zoneData.provinceId,
                city_id: value,
            }, true);

            if (data) {
                setShifts(data.shifts);
                setZoneData(prevState => ({...prevState, [name]: value}));

                navigate(`/requests?order=${activeOrder}&province_id=${zoneData.provinceId}&city_id=${value}`);
            }

        } else {
            const cityData = await fetchData(`assets/provinces/${value}/cities`, 'get', {});

            if (cityData) {
                setCities(cityData.cities);
                setZoneData(prevState => ({...prevState, [name]: value, cityId: 'not-selected'}));
            }
        }
    }

    const changeSortHandler = (e, order) => {
        e.preventDefault();

        if(province_id && city_id) {
            navigate(`/requests?order=${order}&province_id=${province_id}&city_id=${city_id}`);
        } else {
            navigate(`/requests?order=${order}`);
        }

    }

    return (
        <>
            <div className='container-lg my-lg-5 mb-5 rtl'>
                <MobileSort clickHandler={() => setMobileSortModal(true)}
                            title='مرتب‌سازی بر اساس:'
                            sortName={SHIFT_ORDERS.find(item => item.order === activeOrder).name}/>

                <div className='d-flex align-items-center flex-wrap justify-content-between'>
                    <h3 className='success-color fw-normal'>شیفت های درخواست شده</h3>
                    <ZoneOptions>
                        <i className='icon-location'/>
                        <div>
                            <select name='provinceId'
                                    value={zoneData.provinceId}
                                    onChange={zoneChangeHandler}>
                                <option value='not-selected' disabled>انتخاب استان</option>
                                {
                                    provinces.map(item => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                            <i className='icon-arrow'/>
                        </div>
                        <div>
                            <select name='cityId'
                                    value={zoneData.cityId}
                                    onChange={zoneChangeHandler}
                                    disabled={zoneData.provinceId === 'not-selected'}>
                                <option value='not-selected' disabled>انتخاب شهر</option>
                                {
                                    cities.map(item => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                            <i className='icon-arrow'/>
                        </div>
                    </ZoneOptions>
                </div>
                <div className='d-none d-lg-flex align-items-center mt-4'>
                    <i className='icon-sort ms-2'/>
                    <p className='mb-0 dark-gray'>مرتب‌سازی بر اساس:</p>
                    <SortByLists>
                        {
                            SHIFT_ORDERS.map((item, index) => (
                                <SortByItem className={activeOrder === item.order ? 'active-sort' : ''} key={index}>
                                    <Link to={`/requests?order=${item.order}`} onClick={(e) => changeSortHandler(e, item.order)}>{item.name}</Link>
                                </SortByItem>
                            ))
                        }
                    </SortByLists>
                </div>
                <div className='row mt-5'>
                    {
                        shifts.map(item => (
                            <div className='col-6 col-md-4 col-xxl-3 mb-4 px-max-sm-2' key={item.id}>
                                <ShiftCard item={item}
                                           shiftsModalHandler={() => shiftsModalHandler(item)}/>
                            </div>
                        ))
                    }
                </div>
            </div>

            <Modal open={!!shiftsModal.length} onClose={() => setShiftsModal([])}
                   classNames={{modal: 'c-modal-container'}}
                   closeIcon={<i className='icon-close-circle'/>} center>
                <ShiftModalContainer className='row rtl justify-content-center'>
                    {
                        shiftsModal?.map((item, index) => (
                            <div className='col-6 col-md-4 col-xxl-3 col-xxl-4 my-2' key={index}>
                                <ShiftCard item={item} showAllShifts/>
                            </div>
                        ))
                    }
                </ShiftModalContainer>
            </Modal>

            <CustomSheet isOpen={mobileSortModal} onClose={() => setMobileSortModal(false)}
                         snapPoints={[.7, 0.5, 100, 0]}>
                <Sheet.Container>
                    <Sheet.Header>
                        <div className='d-flex align-items-center justify-content-center px-2 py-3 rtl'>
                            <button className='btn-text ms-auto pt-2' onClick={() => setMobileSortModal(false)}>
                                <i className='icon-close-circle'/>
                            </button>
                            <p className='dark-gray mb-0 flex-grow-1 text-center ms-5'>مرتب‌سازی بر اساس</p>
                        </div>
                    </Sheet.Header>

                    <Sheet.Content>
                        <ul className='l-s-t-none mt-3 mb-0 p-0'>
                            {
                                SHIFT_ORDERS.map((item, index) => (
                                    <MobileSortItem className={activeOrder === item.order ? 'active-sort' : ''}
                                                    key={index}>
                                        <Link to={`/requests?order=${item.order}`} onClick={(e) => changeSortHandler(e, item.order)}>{item.name}</Link>
                                        {
                                            activeOrder === item.order &&
                                            <i className='icon-tick-circle tick'/>
                                        }
                                    </MobileSortItem>
                                ))
                            }
                        </ul>
                    </Sheet.Content>
                </Sheet.Container>

                <Sheet.Backdrop/>
            </CustomSheet>
        </>
    );
};

export default Requests;
